// Public surface of the avatars feature. Editor + render code should import
// from here rather than reaching into subfolders directly.

export { default as AvatarCard } from "./components/avatarCard";
export { default as AvatarLookCard } from "./components/avatarLookCard";
export { default as LookGallery } from "./components/lookGallery";
export { default as CreateAvatarModal } from "./components/createAvatarModal";
export { default as AddLookModal } from "./components/addLookModal";
export { default as PublicAvatarBrowser } from "./components/publicAvatarBrowser";
export type { PublicLookSelection } from "./components/publicAvatarBrowser";

export { useGetAvatars } from "./api/useGetAvatars";
export { useGetAvatar } from "./api/useGetAvatar";
export { useGetPublicAvatars } from "./api/useGetPublicAvatars";
export { useGetPublicAvatarLooks } from "./api/useGetPublicAvatarLooks";
export { useCreatePhotoAvatar } from "./api/useCreatePhotoAvatar";
export { useCreateVideoAvatar } from "./api/useCreateVideoAvatar";
export { useCreatePromptAvatar } from "./api/useCreatePromptAvatar";
export { useAddPhotoLook, useAddPromptLook } from "./api/useAddAvatarLook";
export { useUpdateAvatar } from "./api/useUpdateAvatar";
export {
    useDeleteAvatar,
    useDeleteAvatarLook,
} from "./api/useDeleteAvatar";
export {
    useStartAvatarConsent,
    useRefreshAvatar,
} from "./api/useAvatarConsent";
export { useEngineCapabilities } from "./hooks/useEngineCapabilities";

export type {
    Avatar,
    AvatarLook,
    AvatarWithLooks,
    LomdaSceneAvatar,
    SceneAvatarCorner,
    SceneAvatarBackground,
    SceneAvatarTransform,
    SceneAvatarStyle,
    SceneAvatarShadow,
} from "./types";
export {
    avatarFromDbRow,
    lookFromDbRow,
    resolveDefaultLook,
    hasRenderableEngine,
} from "./types";
export { DEFAULT_AVATAR_CORNER_SIZE } from "./lib/constants";
export {
    resolveAvatarTransform,
    defaultTransform,
    snapToCell,
    clampTransform,
    type AvatarAlignCell,
} from "./lib/avatarTransform";
